import { render, staticRenderFns } from "./FinanceSummary.vue?vue&type=template&id=24f5f31b"
import script from "./FinanceSummary.vue?vue&type=script&lang=js"
export * from "./FinanceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports